import React, { useState, useContext, useEffect, FormEvent } from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { RouteComponentProps, withRouter } from "react-router-dom";
import MediaQuery from "react-responsive";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import Col from "react-bootstrap/Col";
import { InputGroup, Form } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { reducer } from "../../../context";
import actionType from "../../../context/actionType";
import AssetListItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/AssetListItem";
import GeneralProjectItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/GeneralProjectItem";
import LabelInput from "../../Auth/LabelInput";
import FormDropdown from "../../Auth/FormDropdown";
import "./style.css";
import agent from "../../../agent";
import Api from "../../../helpers/Api";
import { logResponse } from "../../../helpers/Logger";
import lodash from "lodash";
import { UserToken } from "../../../interface/Server/";
import { isInvalidSession, resetSession } from "../../../helpers/ErrorHandler";

interface Props extends RouteComponentProps {}
interface PAYMENT_LANG {
  [key: string]: any;
}

const PAYMENT_TYPES = [
  {
    name: "Visa",
    imgUrl:
      "data:image/png;base64,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",
    style: { height: 100 },
  },
  {
    name: "MasterCard",
    imgUrl:
      "data:image/png;base64,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",
    style: { height: 65 },
  },
];
const PAYMENT_LANG: PAYMENT_LANG = {
  zhTW: "zh_TW",
  en: "en_GB",
  cn: "zh_CN",
};

const Payment: React.FunctionComponent<Props> = (props) => {
  const { t, i18n } = useTranslation();
  console.log("i18n.language", i18n.language);
  const [hasError, setHasError] = useState({
    message: false,
    nameplate: false,
  });
  const [user, setUser] = useState<UserToken>({ userFullName: "" });
  const { formReducer, configReducer } = useContext(reducer);
  const [paymentForm, setForm] = useState({
    paymentType: "",
    cardNumber: "",
    cardHolder: "",
    cvv: "",
    expiryMonth: "",
    expiryYear: "",
  });
  const [tributeAmount, setTributeAmount] = useState(0);
  useEffect(() => {
    const formDetails = sessionStorage.getItem("SAVED_FORM_DETAILS");
    if (!!formDetails) {
      // JOSH TODO - clear saved form details after completing flow, confirm logic with Jack
      const parsedForm = JSON.parse(formDetails);
      setUser({
        userFullName: `${parsedForm.firstName || ""} ${
          parsedForm.lastName || ""
        }`,
      });
      return;
    }
    const token = sessionStorage.getItem("SESSION_TOKEN");
    if (token) {
      setUser(JSON.parse(token));
    }
  }, []);
  const setOption = (param: string) => (value: any) => {
    setForm({
      ...paymentForm,
      [param]: value,
    });
  };
  useEffect(() => {
    const loadAmount = sessionStorage.getItem("DONATION_AMOUNT");
    setTributeAmount(loadAmount ? Number(loadAmount) : 0); //TODO JACK: Load tribute amount and set to state and display using 'tributeAmount'

    const vipAmount = sessionStorage.getItem("VIP_AMOUNT");

    if (vipAmount) {
      setTributeAmount(Number(vipAmount));
    }
    const asset = sessionStorage.getItem("SELECTED_ASSET");
    const project = sessionStorage.getItem("SELECTED_PROJECT");
    const selected = asset
      ? { selectedAsset: JSON.parse(asset) }
      : project
      ? { selectedProject: JSON.parse(project) }
      : undefined;
    if (selected) {
      formReducer.dispatch({
        type: actionType.form.REFRESH_STAGE,
        payload: {
          nextStep: 3,
          ...selected,
        },
      });
    }
    formReducer.dispatch({
      type: actionType.form.SET_SCREEN,
      payload: {
        screen: "payment",
      },
    });
  }, []);

  const renderConfirmButton = () => {
    return (
      <Button
        size={"lg"}
        onClick={async () => {
          console.log(paymentForm);
          let auth = sessionStorage.getItem("auth");
          const headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: "" + auth,
          };
          let apiBody = {
            paymentMethod: paymentForm.paymentType,
            currency: "",
            amount: 0,
          };
          const isGeneralProject = !!formReducer.state.selectedProject;
          if (isGeneralProject) {
            apiBody["currency"] = "HKD";
            apiBody["amount"] = tributeAmount;
          }
          const paymentEndpoint = isGeneralProject ? "generalProject" : "asset";
          fetch(
            `${Api.path(window.location)}/donate/${paymentEndpoint}/prepay`,
            {
              method: "POST",
              headers: headers,
              body: JSON.stringify(apiBody),
            }
          )
            .then((result) => {
              if (result.status === 401) {
                throw "Invalid Session";
              }
              return result.json();
            })
            .then((resJson) => {
              const { data, msg } = resJson;
              logResponse(
                configReducer.state.debugMode,
                `donate/prepay: ${msg}`
              );
              if (isInvalidSession(resJson)) {
                throw "Invalid Session";
              }
              if (msg == "SKIP") {
                props.history.push("/auth/payment/complete/successed");
                return;
              }
              if (msg == "OK") {
                const {
                  action,
                  chargetotal,
                  currency,
                  hash,
                  hashExtended,
                  hash_algorithm,
                  mode,
                  oid,
                  paymentMethod,
                  responseFailURL,
                  responseSuccessURL,
                  transactionNotificationURL,
                  storename,
                  timezone,
                  txndatetime,
                  txntype,
                } = data;
                let urlArr = [
                  `${action}?`,
                  `chargetotal=${chargetotal}&`,
                  `currency=${currency}&`,
                  `hash=${hash}&`,
                  `hash_algorithm=${hash_algorithm}&`,
                  `mode=${mode}&`,
                  `oid=${oid}&`,
                  `paymentMethod=${paymentMethod}&`,
                  `responseFailURL=${responseFailURL}&`,
                  `responseSuccessURL=${responseSuccessURL}&`,
                  `transactionNotificationURL=${transactionNotificationURL}&`,
                  `storename=${storename}&`,
                  `timezone=${timezone}&`,
                  `txndatetime=${txndatetime}&`,
                  `txntype=${txntype}&`,
                  `language=${PAYMENT_LANG[i18n.language]}`,
                ];
                let url = lodash.join(urlArr, "");
                window.location.replace(url);
              } else {
              }
            })
            .catch(() => {
              resetSession(formReducer);
            });

          // let failed = false;
          // try {
          //     const result = await agent.payment.provideSecurityPaymentDataForTransaction();
          //     console.log('transaction result: ', result);
          // } catch (error) {
          //     console.log('error:', error);
          //     failed = true;
          // }
          // if(failed) {
          //     return;
          // }
          // if(props.history && props.history.push) {
          //     props.history.push('/auth/payment/complete');
          //     formReducer.dispatch({
          //         type: actionType.form.GO_TO_FORM_STAGE,
          //         payload: {
          //             nextStep: 2,
          //         },
          //     })
          // }
        }}
        variant={"primary"}
        disabled={!paymentForm.paymentType}
        style={{
          width: "301px",
          height: "57px",
          backgroundColor: "#2c3e50",
          // color: verified ? '#FFFFFF' : '#78848f',
          borderColor: "#2c3e50",
          marginBottom: 12,
        }}
      >
        {t("confirm")}
      </Button>
    );
  };
  const renderComponent = () => {
    var vip_greeting = sessionStorage.getItem("VIP_GREETING");

    return (
      <Container
        style={{
          width: "100%",
          padding: 0,
          ...(isMobile ? { paddingLeft: 8, paddingRight: 8 } : {}),
        }}
      >
        <div
          style={{
            fontSize: "1.4rem",
            marginBottom: 9,
            paddingTop: 10,
            fontFamily: "Rambla",
          }}
        >
          {user &&
            `${t("hello", {
              user:
                (user && (user.userFullName || user.firstName)) ||
                formReducer.state.userName ||
                vip_greeting ||
                "",
            })}`}
        </div>
        <div
          style={{
            fontFamily: "Rambla",
            fontSize: "1.4rem",
            display: "flex",
            borderStyle: "solid",
            borderWidth: "0px 0px 1px 0px",
            borderColor: "black",
            paddingTop: "10px",
          }}
        >
          {t("selectedItem")}
        </div>
        <Row style={{ padding: 0, margin: 0, marginTop: 9 }}>
          <Col style={{ padding: 0, margin: 0 }}>
            {formReducer.state.selectedAsset && (
              <AssetListItem
                displayImage
                asset={formReducer.state.selectedAsset}
                hideButton
                nameplateDisplay
                isMobile
              />
            )}
            {formReducer.state.selectedProject && (
              <GeneralProjectItem
                item={formReducer.state.selectedProject}
                hideButton
                nameplateDisplay
                amount={tributeAmount}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="basic-text">{t("selectCreditCard")}</div>
            <Row
              style={{
                padding: 0,
                margin: 0,
                marginTop: 32,
                marginBottom: 41,
                ...(isMobile ? { justifyContent: "space-between" } : {}),
              }}
            >
              {PAYMENT_TYPES.map((type, index) => (
                <React.Fragment key={index}>
                  <MediaQuery query="(max-width: 1023px)">
                    <div
                      style={{
                        width: "40vw",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        ...(index > 0 ? { marginLeft: 23 } : {}),
                      }}
                    >
                      <Form.Check style={{ height: "100%", paddingBottom: 32 }}>
                        <Form.Check.Input
                          onClick={() => setOption("paymentType")(type.name)}
                          type="radio"
                          name="payment"
                          id={`id-${type.name}`}
                        />
                      </Form.Check>
                      <div key={type.name} className="mobile-icon-container">
                        <img style={type.style} src={type.imgUrl} />
                      </div>
                    </div>
                  </MediaQuery>
                  <MediaQuery query="(min-width: 1024px)">
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        marginRight: 42,
                      }}
                    >
                      <Form.Check style={{ height: "100%", paddingBottom: 32 }}>
                        <Form.Check.Input
                          onClick={() => setOption("paymentType")(type.name)}
                          type="radio"
                          name="payment"
                          id={`id-${type.name}`}
                        />
                      </Form.Check>
                      <div key={type.name} className="icon-container">
                        <img style={type.style} src={type.imgUrl} />
                      </div>
                    </div>
                  </MediaQuery>
                </React.Fragment>
              ))}
            </Row>
            <div className="basic-text">{t("willRedirectToFirstData")}</div>
          </Col>
        </Row>

        {/* {!!paymentForm.paymentType &&
            <>
                <InputGroup as={Row} style={{ padding: 0, margin: 0 }}>
                    <LabelInput label="Card Number" placeholder="" handleOnChange={setOption('cardNumber')} />
                    <LabelInput label="Cardholder Name" placeholder="" handleOnChange={setOption('cardHolder')} style={{ marginLeft: 19 }} />
                </InputGroup>

                <InputGroup as={Row} id="container-title-english-name" style={{ padding: 0, margin: 0, marginTop: 18 }}>
                    <LabelInput label="CVV" placeholder="" handleOnChange={setOption('cvv')} />
                    <Col style={{ padding: 0, margin: 0, marginLeft: 19 }}>
                        <FormDropdown
                            options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
                            currentSelection={paymentForm.expiryMonth}
                            placeholder="Month"
                            onClick={(month: any) => setOption('expiryMonth')(month)}
                        />
                    </Col>
                    <Col style={{ padding: 0, margin: 0, marginLeft: 20 }}>
                        <FormDropdown
                            options={['2019', '2020', '2021', '2022', '2023']}
                            currentSelection={paymentForm.expiryYear}
                            placeholder="Year"
                            onClick={(year: any) => setOption('expiryYear')(year)}
                        />
                    </Col>
                </InputGroup>
            </>
        } */}

        <Row
          style={{
            justifyContent: isMobile ? "center" : "space-between",
            padding: 0,
            margin: 0,
            marginTop: 41,
            width: "100%",
          }}
        >
          {isMobile && renderConfirmButton()}
          <Button
            size={"lg"}
            onClick={() => props.history.goBack()}
            variant={"primary"}
            style={{
              width: "301px",
              height: "57px",
              backgroundColor: "#2c3e50",
              borderColor: "#2c3e50",
              marginBottom: isMobile ? 12 : 0,
            }}
          >
            {t("form.revise")}
          </Button>
          {!isMobile && renderConfirmButton()}
        </Row>
      </Container>
    );
  };

  return (
    <Container
      style={{
        width: "100%",
        padding: 0,
        ...(isMobile ? { paddingLeft: 8, paddingRight: 8 } : {}),
      }}
    >
      <Row style={{ padding: 0, margin: 0 }}>
        <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
        <Col style={{ padding: 0, margin: 0 }} xs={12} sm={10} md={10} lg={10}>
          {renderComponent()}
        </Col>
        <Col style={{ padding: 0, margin: 0 }} xs={0} sm={1} md={1} lg={1} />
      </Row>
    </Container>
  );
};

export default withRouter(Payment);
